export const APP_NAME = 'Synth Cohost Live';

export const NAV_ITEMS = [
  { id: 'preview', label: 'Preview', path: '/' },
  { id: 'avatar', label: 'Avatar', path: '/avatar' },
  { id: 'streaming', label: 'Streaming', path: '/streaming' },
  { id: 'settings', label: 'Settings', path: '/settings' },
] as const;

export type NavItemId = (typeof NAV_ITEMS)[number]['id'];
